import React from 'react'
import { Typography, useTheme } from '@mui/material'
import ActionButtons from '../Buttons/ActionButtons'
import { ContainedButtonVariant } from '../Buttons/ContainedButton'
import { useTranslation } from 'react-i18next'
import ConfirmationModal from './ConfirmationModal'

interface UpdateUserScreeningWarningModalProps {
  isOpen: boolean
  onClose: () => void
  warningMessage?: string
}

const UpdateUserScreeningWarningModal: React.FC<
  UpdateUserScreeningWarningModalProps
> = ({ isOpen, warningMessage, onClose }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      handleFormSubmit={onClose}
      isOpen={isOpen}
      dialogContent={
        <Typography
          sx={{
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: theme.spacing(2),
          }}
        >
          {t(
            'UserScreeningTab.Modal.UpdateUserScreeningWarning',
            '{{message}}',
            {
              message: warningMessage,
            }
          )}
        </Typography>
      }
      dialogActions={
        <ActionButtons primaryButtonLabel={ContainedButtonVariant.Ok} />
      }
    />
  )
}

export default UpdateUserScreeningWarningModal
